function getVoid(): void {}
export const nothing: void = getVoid()
